import { Injectable, inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../api/api.service';

export interface InvestorSearchResult {
  id: string;
  fullName: string | null;
  email: string | null;
  phone: string | null;
}

@Injectable({ providedIn: 'root' })
export class InvestorsService {
  private api = inject(ApiService);

  searchInvestors(options: {
    search?: string;
    page?: number;
    perPage?: number;
  }): Observable<{ items: InvestorSearchResult[]; total: number }> {
    let params = new HttpParams()
      .set('per_page', String(options.perPage ?? 20))
      .set('page', String(options.page ?? 1));
    if (options.search) {
      params = params.set('search', options.search);
    }
    return this.api.get<any>('/API2/investors', params).pipe(
      map((resp) => {
        const meta = resp?.meta || {};
        const rawItems = Array.isArray(resp?.data) ? resp.data : [];
        const items: InvestorSearchResult[] = rawItems.map((row: any) => ({
          id: String(row?.id ?? ''),
          fullName: String(row?.full_name ?? row?.fullName ?? '').trim() || null,
          email: row?.email ?? null,
          phone: row?.phone ?? null,
        }));
        return {
          items,
          total: Number(meta.total ?? items.length),
        };
      })
    );
  }
}
